const KEY = 'theme';

export const getTheme = () => localStorage.getItem(KEY) || 'dark';

export const applyTheme = (t) => {
    document.documentElement.setAttribute('data-theme', t);
};

export const setTheme = (t) => {
    localStorage.setItem(KEY, t);
    applyTheme(t);
};

export const toggleTheme = () => {
    const next = getTheme() === 'light' ? 'dark' : 'light';
    setTheme(next);
    return next;
};
